import { IntegrationServices } from '@sequencehq/api'
import { PaymentOrigin } from 'Invoices/types'

export const PAYMENT_ORIGIN_LABELS: Record<PaymentOrigin, string> = {
  SEQUENCE: 'Sequence',
  STRIPE: 'Stripe',
  GOCARDLESS: 'GoCardless',
  XERO: 'Xero',
  QUICKBOOKS: 'QuickBooks',
  RILLET: 'Rillet',
  NETSUITE: 'NetSuite'
}

export const PAYMENT_ORIGIN_LOGOS: Record<
  PaymentOrigin,
  IntegrationServices | null
> = {
  SEQUENCE: null,
  STRIPE: 'Stripe',
  GOCARDLESS: 'GoCardless',
  XERO: 'Xero',
  QUICKBOOKS: 'QuickBooks_Online',
  RILLET: 'Rillet',
  NETSUITE: 'NetSuite'
}

// Shown when the backend omits the origin, or sends one we have no label for.
export const UNKNOWN_PAYMENT_ORIGIN_LABEL = '—'

export const PAYMENT_ORIGIN_LOGO_SIZE = 16
